<template>
  <div>
    <Breadcrumbs
      :paths="[$route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.preference.title") }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="mt-1">
      <v-expansion-panels v-model="preference_panel" accordion class="accordion">
        <!-- preference_panel[0]: translate_train -->
        <v-expansion-panel v-if="['the-reading'].indexOf($store.getters.domain) < 0">
          <v-expansion-panel-header>
            <template v-if="['the-reading'].indexOf($store.getters.domain) < 0">
              {{ $t("message.preference.category_translate_train") }}
            </template>
            <!--
            <template v-else>
              {{ $t("message.preference.category_translate") }}
            </template>
            -->
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs
              background-color="primary"
              dark
              v-model="translate_train_tab"
            >
              <!--
              <v-tab href="#translate">
                {{ $t("message.preference.item_translate") }}
              </v-tab>
              -->
              <template v-if="['the-reading'].indexOf($store.getters.domain) < 0">
                <v-tab href="#train">
                  {{ $t("message.preference.item_train") }}
                </v-tab>
              </template>

              <v-tabs-items v-model="translate_train_tab">
                <!-- tab[0]: translate -->
                <!--
                <v-tab-item value="translate">
                  <v-card class="pa-5">
                    <p>{{ $t("message.preference.item_translate_description") }}</p>
                    <TranslateParameter
                      ref="translate_parameter"
                      :visible_panel="['command', 'lang_pair']"
                      :mode="mode"
                      :preference="true"
                    >
                    </TranslateParameter>
                  </v-card>
                </v-tab-item>
                -->

                <template v-if="['the-reading'].indexOf($store.getters.domain) < 0">
                  <!-- tab[1]: train -->
                  <v-tab-item value="train">
                    <v-card class="pa-5">
                      <p>{{ $t("message.preference.item_train_description") }}</p>
                      <TrainParameter
                        ref="train_parameter"
                        :visible_panel="['command', 'lang_pair', 'field', 'detail']"
                      >
                      </TrainParameter>
                    </v-card>
                  </v-tab-item>
                </template>
              </v-tabs-items>
            </v-tabs>
            <!--
            <p class="text-right pt-5">
              <v-btn
                @click="reset_translate_train"
              >
                {{ $t("message.preference.clear", { category: $t("message.preference.category_translate_train") }) }}
              </v-btn>
            </p>
            -->
          </v-expansion-panel-content>
        </v-expansion-panel>
        <template v-if="['the-reading'].indexOf($store.getters.domain) < 0">
          <!-- preference_panel[1]: editor -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t("message.preference.category_editor") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs
                background-color="primary"
                dark
                v-model="editor_tab"
              >
                <v-tab href="#editor">
                  {{ $t("message.preference.item_editor") }}
                </v-tab>
                <v-tab href="#shortcut">
                  {{ $t("message.preference.item_shortcut") }}
                </v-tab>
                <v-tab href="#color">
                  {{ $t("message.preference.item_color") }}
                </v-tab>

                <v-tabs-items v-model="editor_tab">
                  <!-- tab[0]: editor -->
                  <v-tab-item value="editor">
                    <v-card class="pa-5">
                      <p class="mb-5">
                        {{ $t("message.preference.item_editor_description") }}
                      </p>
                      <v-expansion-panels v-model="editor_panel" accordion class="accordion">
                        <!-- editor_panel[0]: file -->
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <template v-slot:default="{ open }">
                              <v-row>
                                <v-col cols="4">
                                  {{ $t("message.preference.sub_title_file") }}
                                </v-col>
                                <v-col cols="8">
                                  <span v-if="!open">
                                    <!--
                                    {{ $t('message.preference.content_mode') }}={{ $t("message.common." + content_mode) }},&nbsp;
                                    -->
                                    {{ $t('message.preference.enable_backup') }}={{ $t('message.preference.' + (enable_backup ? 'enable' : 'disable')) }}
                                  </span>
                                </v-col>
                              </v-row>
                            </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <!--
                            <v-subheader class="pl-0">
                              {{ $t("message.preference.sub_title_file_open") }}
                            </v-subheader>
                            <v-select
                              class="mb-2"
                              :label="$t('message.preference.content_mode')"
                              :items="content_modes"
                              item-text="label"
                              item-value="value"
                              v-model="content_mode"
                            >
                              <template v-slot:item="props">
                                {{ $t("message.common." + props.item.label) }}
                              </template>
                              <template v-slot:selection="props">
                                {{ $t("message.common." + props.item.label) }}
                              </template>
                            </v-select>
                            -->
                            <v-subheader class="pl-0">
                              {{ $t("message.preference.sub_title_file_save") }}
                            </v-subheader>
                            <v-switch
                              class="mb-2"
                              :label="$t('message.preference.enable_backup')"
                              v-model="enable_backup"
                            >
                            </v-switch>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <!-- editor_panel[1]: edit -->
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <template v-slot:default="{ open }">
                              <v-row>
                                <v-col cols="4">
                                  {{ $t("message.preference.sub_title_edit") }}
                                </v-col>
                                <v-col cols="8">
                                  <span v-if="!open">
                                    {{ $t('message.preference.history_limit') }}={{ history_limit }},&nbsp;
                                    {{ $t('message.preference.case_sensitive') }}={{ case_sensitive ? $t('message.common.yes') : $t('message.common.no') }}
                                  </span>
                                </v-col>
                              </v-row>
                            </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-subheader class="pl-0">
                              {{ $t("message.preference.sub_title_edit_history") }}
                            </v-subheader>
                            <v-select
                              class="mb-2"
                              :label="$t('message.preference.history_limit')"
                              :items="history_limits"
                              item-text="label"
                              item-value="value"
                              v-model="history_limit"
                            >
                            </v-select>
                            <v-subheader class="pl-0">
                              {{ $t("message.preference.sub_title_edit_search") }}
                            </v-subheader>
                            <v-switch
                              v-model="case_sensitive"
                              :label="$t('message.preference.case_sensitive')"
                            ></v-switch>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <!-- editor_panel[2]: display -->
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <template v-slot:default="{ open }">
                              <v-row>
                                <v-col cols="4">
                                  {{ $t("message.preference.sub_title_display") }}
                                </v-col>
                                <v-col cols="8">
                                  <span v-if="!open">
                                    {{ $t('message.preference.font_size') }}={{ font_size }},&nbsp;
                                    {{ $t('message.preference.layout_mode') }}={{ $t('message.preference.' + layout_mode) }},&nbsp;
                                    {{ $t('message.preference.menu_mode') }}={{ $t('message.preference.' + menu_mode) }},&nbsp;
                                    {{ $t('message.preference.sentence_mode') }}={{ $t('message.preference.' + sentence_mode) }},&nbsp;
                                    {{ $t('message.preference.memo_mode') }}={{ $t('message.preference.' + (memo_mode ? 'enable' : 'disable')) }}
                                  </span>
                                </v-col>
                              </v-row>
                            </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-slider
                              class="mb-2"
                              :label="$t('message.preference.font_size')"
                              max="1.5"
                              min="0.625"
                              step="0.125"
                              v-model="font_size"
                              thumb-label
                            ></v-slider>
                            <v-radio-group
                              class="mb-2"
                              :label="$t('message.preference.layout_mode')"
                              :column="false"
                              v-model="layout_mode"
                            >
                              <v-radio
                                v-for="l in layout_modes"
                                :label="$t('message.preference.' + l)"
                                :key="l"
                                :value="l"
                                class="pl-5"
                              ></v-radio>
                            </v-radio-group>
                            <v-radio-group
                              class="mb-2"
                              :label="$t('message.preference.menu_mode')"
                              :column="false"
                              v-model="menu_mode"
                            >
                              <v-radio
                                v-for="l in menu_modes"
                                :label="$t('message.preference.' + l)"
                                :key="l"
                                :value="l"
                                class="pl-5"
                              ></v-radio>
                            </v-radio-group>
                            <v-radio-group
                              class="mb-2"
                              :label="$t('message.preference.sentence_mode')"
                              :column="false"
                              v-model="sentence_mode"
                            >
                              <v-radio
                                v-for="l in layout_modes"
                                :label="$t('message.preference.' + l)"
                                :key="l"
                                :value="l"
                                class="pl-5"
                              ></v-radio>
                            </v-radio-group>
                            <v-switch
                              :label="$t('message.preference.memo_mode')"
                              v-model="memo_mode"
                            >
                            </v-switch>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card>
                  </v-tab-item>

                  <!-- tab[1]: shortcut -->
                  <v-tab-item value="shortcut">
                    <v-card class="pa-5">
                      <p class="mb-5">
                        {{ $t("message.preference.item_shortcut_description") }}
                      </p>
                      <v-expansion-panels v-model="shortcut_panel" accordion class="accordion">
                        <v-expansion-panel v-for="item in menu_items" :key="item.title">
                          <v-expansion-panel-header>
                            <template v-slot:default="{ open }">
                              {{ $t("message.editor.menu_bar." + item.title) }}
                            </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <template v-for="sub_item in item.sub_items">
                              <template v-if="sub_item.type !== 'divider'">
                                <template v-if="(!('sub_sub_items' in sub_item)
                                  || ['undo', 'redo'].indexOf(sub_item.title) >= 0)
                                  && sub_item.name in shortcut
                                  && (!('visible' in sub_item) || sub_item.visible())">
                                  <v-card
                                    class="d-flex align-center"
                                    flat
                                  >
                                    <label>
                                      {{ $t('message.editor.menu_bar.' + sub_item.name) }}
                                    </label>
                                    <v-checkbox
                                      :input-value="true"
                                      :disabled="true"
                                      class="pl-2"
                                    ></v-checkbox>
                                    <label class="v-label v-label--is-disabled theme--light">
                                      Ctrl/
                                      <v-icon small>mdi-apple-keyboard-command</v-icon>
                                    </label>
                                    <v-checkbox
                                      v-model="shortcut[sub_item.name].shift"
                                      class="pl-2"
                                      @change="shortcut[sub_item.name].key = ''"
                                    ></v-checkbox>
                                    <label>
                                      Shift
                                    </label>
                                    <v-select
                                      label="Key"
                                      :items="keys(shortcut[sub_item.name])"
                                      item-text="label"
                                      item-value="value"
                                      v-model="shortcut[sub_item.name].key"
                                      class="pl-2"
                                    >
                                    </v-select>
                                    <template v-if="'context_menu' in sub_item">
                                      <v-switch
                                        v-model="shortcut[sub_item.name].context_menu"
                                        :label="$t('message.preference.context_menu')"
                                        class="pl-2"
                                      ></v-switch>
                                    </template>
                                  </v-card>
                                </template>
                                <template v-else>
                                  <v-subheader class="pl-0">
                                    {{ $t("message.editor.menu_bar." + sub_item.name) }}
                                  </v-subheader>
                                  <template v-for="sub_sub_item in sub_item.sub_sub_items">
                                    <template v-if="sub_sub_item.type !== 'divider'
                                      && sub_sub_item.name in shortcut
                                      && (!('visible' in sub_sub_item) || sub_sub_item.visible())">
                                      <v-card
                                        class="d-flex align-center pl-4"
                                        flat
                                      >
                                        <label>
                                          {{ $t('message.editor.menu_bar.' + sub_sub_item.name) }}
                                        </label>
                                        <v-checkbox
                                          :input-value="true"
                                          :disabled="true"
                                          class="pl-2"
                                        ></v-checkbox>
                                        <label class="v-label v-label--is-disabled theme--light">
                                          Ctrl/
                                          <v-icon small>mdi-apple-keyboard-command</v-icon>
                                        </label>
                                        <v-checkbox
                                          v-model="shortcut[sub_sub_item.name].shift"
                                          class="pl-2"
                                          @change="shortcut[sub_sub_item.name].key = ''"
                                        ></v-checkbox>
                                        <label>
                                          Shift
                                        </label>
                                        <v-select
                                          label="Key"
                                          :items="keys(shortcut[sub_sub_item.name])"
                                          item-text="label"
                                          item-value="value"
                                          v-model="shortcut[sub_sub_item.name].key"
                                          class="pl-2"
                                        >
                                        </v-select>
                                        <template v-if="'context_menu' in sub_sub_item">
                                          <v-switch
                                            v-model="shortcut[sub_sub_item.name].context_menu"
                                            :label="$t('message.preference.context_menu')"
                                            class="pl-2"
                                          ></v-switch>
                                        </template>
                                      </v-card>
                                    </template>
                                  </template>
                                </template>
                              </template>
                            </template>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                      <p class="text-right pt-5 pr-3">
                        <v-btn
                          @click="shortcut = unset_shortcut()"
                        >
                          {{ $t("message.preference.unset_all_shortcut") }}
                        </v-btn>
                      </p>
                    </v-card>
                  </v-tab-item>

                  <!-- tab[2]: color -->
                  <v-tab-item value="color">
                    <v-card class="pa-5">
                      <p class="mb-5">
                        {{ $t("message.preference.item_color_description") }}
                      </p>
                      <v-expansion-panels v-model="colors_panel" accordion class="accordion">
                        <v-expansion-panel v-for="(value, key) in color_items" :key="key">
                          <v-expansion-panel-header>
                            <template v-slot:default="{ open }">
                              {{ $t("message.editor.colors." + key) }}
                            </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table>
                              <template v-slot:default>
                                <template v-if="key === 'text'">
                                  <thead>
                                    <tr>
                                      <th>
                                        {{ $t("message.editor.colors.item") }}
                                      </th>
                                      <th>
                                        {{ $t("message.editor.colors.color") }}
                                      </th>
                                      <th>
                                        {{ $t("message.editor.colors.bold") }}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <template v-for="sub_item in value">
                                      <tr>
                                        <td>
                                          <span :style="get_text_style(sub_item)">
                                            {{ $t("message.editor.colors.item_" + sub_item) }}
                                          </span>
                                        </td>
                                        <td>
                                          <v-edit-dialog
                                            :return-value.sync="colors[sub_item].color"
                                            large
                                            save-text="OK"
                                            :cancel-text="$t('message.common.cancel')"
                                          >
                                            <v-card
                                              width="100px"
                                              :style="{
                                                backgroundColor: colors[sub_item].color
                                              }"
                                            >
                                              &nbsp;
                                            </v-card>
                                            <template v-slot:input>
                                              <v-color-picker
                                                v-model="colors[sub_item].color"
                                                dot-size="25"
                                                hide-mode-switch
                                                mode="rgba"
                                                show-swatches
                                                swatches-max-height="200"
                                              >
                                              </v-color-picker>
                                            </template>
                                          </v-edit-dialog>
                                        </td>
                                        <td>
                                          <v-switch
                                            v-model="colors[sub_item].bold"
                                          >
                                          </v-switch>
                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </template>
                                <template v-else>
                                  <thead>
                                    <tr>
                                      <th>
                                        {{ $t("message.editor.colors.item") }}
                                      </th>
                                      <th>
                                        {{ $t("message.editor.colors.border_color") }}
                                      </th>
                                      <th>
                                        {{ $t("message.editor.colors.border_style") }}
                                      </th>
                                      <th>
                                        {{ $t("message.editor.colors.background_color") }}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <template v-for="sub_item in value">
                                      <tr>
                                        <td>
                                          <v-card
                                            class="pa-1"
                                            :style="get_border_style(key, sub_item)"
                                          >
                                            {{ $t("message.editor.colors.item_" + sub_item) }}
                                          </v-card>
                                        </td>
                                        <td>
                                          <v-edit-dialog
                                            :return-value.sync="colors[sub_item].border_color"
                                            large
                                            save-text="OK"
                                            :cancel-text="$t('message.common.cancel')"
                                          >
                                            <v-card
                                              width="100px"
                                              :style="{
                                                backgroundColor: colors[sub_item].border_color
                                              }"
                                            >
                                              &nbsp;
                                            </v-card>
                                            <template v-slot:input>
                                              <v-color-picker
                                                v-model="colors[sub_item].border_color"
                                                dot-size="25"
                                                hide-mode-switch
                                                mode="rgba"
                                                show-swatches
                                                swatches-max-height="200"
                                              >
                                              </v-color-picker>
                                            </template>
                                          </v-edit-dialog>
                                        </td>
                                        <td>
                                          <v-select
                                            :items="border_styles"
                                            item-text="label"
                                            item-value="value"
                                            v-model="colors[sub_item].border_style"
                                          >
                                            <template v-slot:item="props">
                                              <v-card
                                                width="60px"
                                                class="border_style"
                                                :style="border_style(props.item.label)"
                                                flat
                                              >
                                                &nbsp;
                                              </v-card>
                                              &nbsp;
                                              {{ $t("message.editor.colors.border_style_" + props.item.label) }}
                                            </template>
                                            <template v-slot:selection="props">
                                              <v-card
                                                width="60px"
                                                class="border_style"
                                                :style="border_style(props.item.label)"
                                                flat
                                              >
                                                &nbsp;
                                              </v-card>
                                              &nbsp;
                                              {{ $t("message.editor.colors.border_style_" + props.item.label) }}
                                            </template>
                                          </v-select>
                                        </td>
                                        <td>
                                          <v-edit-dialog
                                            :return-value.sync="colors[sub_item].background_color"
                                            large
                                            save-text="OK"
                                            :cancel-text="$t('message.common.cancel')"
                                          >
                                            <v-card
                                              width="100px"
                                              :style="{
                                                backgroundColor: colors[sub_item].background_color
                                              }"
                                            >
                                              &nbsp;
                                            </v-card>
                                            <template v-slot:input>
                                              <v-color-picker
                                                v-model="colors[sub_item].background_color"
                                                dot-size="25"
                                                hide-mode-switch
                                                mode="rgba"
                                                show-swatches
                                                swatches-max-height="200"
                                              >
                                              </v-color-picker>
                                            </template>
                                          </v-edit-dialog>
                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </template>
                              </template>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
              <!--
              <p class="text-right pt-5">
                <v-btn
                  @click="reset_editor"
                >
                  {{ $t("message.preference.clear", { category: $t("message.preference.category_editor") }) }}
                </v-btn>
              </p>
              -->
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
        <!-- preference_panel[2]: system -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t("message.preference.category_system") }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs
              background-color="primary"
              dark
              v-model="system_tab"
            >
              <v-tab href="#lang_select">
                {{ $t("message.preference.item_lang_select") }}
              </v-tab>
              <v-tab href="#notification">
                {{ $t("message.preference.item_notification") }}
              </v-tab>
              <v-tab href="#http_log">
                {{ $t("message.preference.item_http_log") }}
              </v-tab>

              <v-tabs-items v-model="system_tab">
                <!-- tab[0]: lang_select -->
                <v-tab-item value="lang_select">
                  <v-card class="pa-5">
                    <p class="mb-5">
                      {{ $t("message.preference.item_lang_select_description") }}
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon class="mb-1" size="20" v-on="on">mdi-help-circle-outline</v-icon>
                        </template>
                        <span>{{ $t("message.preference.item_lang_select_additional") }}</span>
                      </v-tooltip>
                    </p>
                    <v-select
                      class="mb-2"
                      :items="langs"
                      item-text="label"
                      item-value="value"
                      v-model="lang_select"
                    >
                      <template v-slot:item="props">
                        <template v-if="props.item.value === 'auto'">
                          ({{ $t("message.preference.auto") }})
                        </template>
                        <template v-else>
                          {{ props.item.label }}
                        </template>
                      </template>
                      <template v-slot:selection="props">
                        <template v-if="props.item.value === 'auto'">
                          <v-list-item class="pa-2 pl-0" style="min-height:auto">
                            ({{ $t("message.preference.auto") }})
                          </v-list-item>
                        </template>
                        <template v-else>
                          <v-list-item class="pa-2 pl-0" style="min-height:auto">
                            {{ props.item.label }}
                          </v-list-item>
                        </template>
                      </template>
                    </v-select>
                  </v-card>
                </v-tab-item>

                <!-- tab[1]: notification -->
                <v-tab-item value="notification">
                  <v-card class="pa-5">
                    <p class="mb-8">{{ $t("message.preference.item_notification_description") }}</p>
                    <v-switch
                      v-model="notify_success"
                      :label="$t('message.preference.notify_success')"
                    ></v-switch>
                    <v-select
                      class="mb-2"
                      :label="$t('message.preference.notify_limits')"
                      :items="notify_limits"
                      item-text="label"
                      item-value="value"
                      v-model="notify_limit"
                    >
                      <template v-slot:item="props">
                        <template v-if="props.item.value === -1">
                          {{ $t("message.preference.notify_limit_all") }}
                        </template>
                        <template v-else>
                          {{ props.item.label }}
                        </template>
                      </template>
                      <template v-slot:selection="props">
                        <template v-if="props.item.value === -1">
                          <v-list-item class="pa-2 pl-0" style="min-height:auto">
                            {{ $t("message.preference.notify_limit_all") }}
                          </v-list-item>
                        </template>
                        <template v-else>
                          <v-list-item class="pa-2 pl-0" style="min-height:auto">
                            {{ props.item.label }}
                          </v-list-item>
                        </template>
                      </template>
                    </v-select>
                    <template v-if="notify_success">
                      <v-switch
                        v-model="web_socket"
                        :label="$t('message.preference.websocket')"
                        :hint="$t('message.preference.websocket_desc')"
                        persistent-hint
                      ></v-switch>
                      <v-select
                        ref="job_type"
                        :label="$t('message.preference.job_type')"
                        :items="job_types"
                        item-text="label"
                        item-value="value"
                        v-model="job_type"
                        hide-details
                        multiple
                        class="pt-5"
                        @change="$refs.job_type && $refs.job_type.setMenuIndex(-1)"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item
                            ripple
                            @mousedown.prevent
                            @click="select_all_toggle"
                          >
                            <v-list-item-action>
                              <v-icon :color="job_type.length > 0 ? 'primary' : ''">
                                {{ select_all_icon }}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ $t("message.common.select_all") }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index === 0">
                            <span>{{ item.label }}</span>
                          </v-chip>
                          <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                          >
                            (+{{ job_type.length - 1 }}{{ $t("message.common.others") }})
                          </span>
                        </template>
                      </v-select>
                    </template>
                  </v-card>
                </v-tab-item>

                <!-- tab[2]: http_log -->
                <v-tab-item value="http_log">
                  <v-card class="pa-5">
                    <v-select
                      class="mb-2"
                      :label="$t('message.preference.http_log_limit') + '(HTTP)'"
                      :items="http_log_limits"
                      item-text="label"
                      item-value="value"
                      v-model="http_log_limit"
                    >
                      <template v-slot:item="props">
                        {{ props.item.label }}
                      </template>
                      <template v-slot:selection="props">
                        <v-list-item class="pa-2 pl-0" style="min-height:auto">
                          {{ props.item.label }}
                        </v-list-item>
                      </template>
                    </v-select>
                    <v-select
                      class="mb-2"
                      :label="$t('message.preference.http_log_limit') + '(' + $t('message.common.web_socket') +')'"
                      :items="http_log_limits"
                      item-text="label"
                      item-value="value"
                      v-model="web_socket_log_limit"
                    >
                      <template v-slot:item="props">
                        {{ props.item.label }}
                      </template>
                      <template v-slot:selection="props">
                        <v-list-item class="pa-2 pl-0" style="min-height:auto">
                          {{ props.item.label }}
                        </v-list-item>
                      </template>
                    </v-select>
                    <p class="text-right">
                      <DumpStore></DumpStore>
                    </p>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
            <!--
            <p class="text-right pt-5">
              <v-btn
                @click="reset_system"
              >
                {{ $t("message.preference.clear", { category: $t("message.preference.category_system") }) }}
              </v-btn>
            </p>
            -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <p class="text-right pt-5">
      <v-btn
        color="primary"
        @click="save"
      >
        {{ $t("message.preference.save") }}
      </v-btn>
      <v-btn
        @click="reset"
      >
        {{ $t("message.preference.reset") }}
      </v-btn>
      &nbsp;
      <v-btn to="/">
        {{ $t("message.common.return_home") }}
      </v-btn>
    </p>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
//import TranslateParameter from '../components/TranslateParameter';
import TrainParameter from '../components/TrainParameter';
import DumpStore from '../components/DumpStore';
import { mapGetters } from 'vuex';
import { menu_items } from "../js/editor_menu_items";
import { color_items } from "../js/editor_color_items";
import _cloneDeep from "lodash/cloneDeep";

export default {
  name: 'preference',
  components: {
    Breadcrumbs,
    //TranslateParameter,
    TrainParameter,
    DumpStore
  },
  mixins: [menu_items, color_items],
  data: function(){
    var langs = [
      {
        label: "auto",
        value: "auto"
      }
    ];
    for(var [key, lang] of Object.entries(this.$store.getters.langs)){
      langs.push({
        label: lang.name,
        value: lang.lang
      })
    }
    return {
      module_id: "06",
      mode: "user",
      preference_panel: 0,

      // preference_panel[0]: translate_train
      translate_train_tab: "train",

      // preference_panel[1]: editor
      editor_tab: "default",
      //// tab[0]: default
      editor_panel: 0,
      ////// editor_panel[0]: file
      content_mode: "translated",
      content_modes: [
        {
          "label": "source",
          "value": "source"
        },
        {
          "label": "translated",
          "value": "translated"
        },
        {
          "label": "corpus",
          "value": "corpus"
        },
      ],
      enable_backup: true,

      ////// editor_panel[1]: edit
      history_limit: 20,
      history_limits: [
        {
          "label": "10",
          "value": 10
        },
        {
          "label": "20",
          "value": 20
        },
        {
          "label": "50",
          "value": 50
        },
      ],
      case_sensitive: false,
      ////// editor_panel[2]: display
      font_size: 0.875,
      layout_mode: "vertical",
      layout_modes: [
        "vertical",
        "horizontal"
      ],
      menu_mode: "icon",
      menu_modes: [
        "icon",
        "menu"
      ],
      sentence_mode: "horizontal",
      memo_mode: false,

      //// tab[1]: shortcut
      shortcut_panel: 0,
      shortcut: this.default_shortcut(),

      //// tab[2]: colors
      colors_panel: 0,
      colors: this.default_colors(),
      border_styles: [
        {
          "label": "solid",
          "value": "solid"
        },
        {
          "label": "dotted",
          "value": "dotted"
        },
        {
          "label": "dashed",
          "value": "dashed"
        },
        {
          "label": "bold_solid",
          "value": "bold_solid"
        },
        {
          "label": "bold_dotted",
          "value": "bold_dotted"
        },
        {
          "label": "bold_dashed",
          "value": "bold_dashed"
        }
      ],

      // preference_panel[2]: system
      system_tab: "lang_select",
      //// tab[0]: lang_select
      lang_select: "auto",
      langs: langs,

      //// tab[1]: notification
      notify_success: true,
      notify_limit: -1,
      notify_limits: [
        {
          "label": "5",
          "value": 5
        },
        {
          "label": "10",
          "value": 10
        },
        {
          "label": "all",
          "value": -1
        }
      ],
      web_socket: false,
      job_type: [],
      job_types_all: [
        {
          "label": "translate",
          "value": "translate",
          "invalid_domains": [],
          "invalid_roles": []
        },
        {
          "label": "estimate",
          "value": "estimate",
          "invalid_domains": [],
          "invalid_roles": []
        },
        {
          "label": "train",
          "value": "train",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "corpus_import",
          "value": "corpus_import",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "term_import",
          "value": "term_import",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "similarity",
          "value": "similarity",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "change_name",
          "value": "change_name",
          "invalid_domains": [],
          "invalid_roles": ["user", "group_manager"]
        },
        {
          "label": "change_gid",
          "value": "change_gid",
          "invalid_domains": [],
          "invalid_roles": ["user", "group_manager"]
        },
        {
          "label": "modify",
          "value": "modify",
          "invalid_domains": ['the-reading'],
          "invalid_roles": []
        },
        {
          "label": "batch_user",
          "value": "batch_user",
          "invalid_domains": [],
          "invalid_roles": ["user"]
        },
        {
          "label": "list_user",
          "value": "list_user",
          "invalid_domains": [],
          "invalid_roles": ["user"]
        }
      ],

      //// tab[2]: http_log
      http_log_limit: 10,
      web_socket_log_limit: 30,
      http_log_limits: [
        {
          "label": 0,
          "value": 0
        },
        {
          "label": 10,
          "value": 10
        },
        {
          "label": 30,
          "value": 30
        },
        {
          "label": 100,
          "value": 100
        }
      ]
    }
  },
  mounted: function(){
    if(this.$store.getters.preference != null){
      var preference = this.$store.getters.preference;
      // preference_panel[1]: editor
      //// tab[0]: editor
      if(preference.editor != null){
        if(preference.editor.content_mode != null){
          this.content_mode = preference.editor.content_mode;
        }
        if(preference.editor.enable_backup != null){
          this.enable_backup = preference.editor.enable_backup;
        }
        if(preference.editor.history_limit != null){
          this.history_limit = preference.editor.history_limit;
        }
        if(preference.editor.case_sensitive != null){
          this.case_sensitive = preference.editor.case_sensitive;
        }
        if(preference.editor.font_size != null){
          this.font_size = preference.editor.font_size;
        }
        if(preference.editor.layout_mode != null){
          this.layout_mode = preference.editor.layout_mode;
        }
        if(preference.editor.menu_mode != null){
          this.menu_mode = preference.editor.menu_mode;
        }
        if(preference.editor.sentence_mode != null){
          this.sentence_mode = preference.editor.sentence_mode;
        }
        if(preference.editor.memo_mode != null){
          this.memo_mode = preference.editor.memo_mode;
        }
      }
      //// tab[1]: shortcut
      if(preference.editor != null
        && preference.editor.shortcut != null){
        this.shortcut = _cloneDeep(preference.editor.shortcut);
      }else{
        this.shortcut = {};
      }
      var default_shortcut = this.default_shortcut();
      for(var key in default_shortcut){
        if(!(key in this.shortcut)){
          this.shortcut[key] = default_shortcut[key];
        }
      }
      for(var key in this.shortcut){
        if(!('context_menu' in this.shortcut[key])){
          this.shortcut[key].context_menu = true;
        }
      }
      //// tab[2]: colors
      if(preference.editor != null
        && preference.editor.colors != null){
        this.colors = _cloneDeep(preference.editor.colors);
      }else{
        this.colors = {};
      }
      var default_colors = this.default_colors();
      for(var key in default_colors){
        if(!(key in this.colors)){
          this.colors[key] = default_colors[key];
        }
      }
      // preference_panel[2]: system
      //// tab[0]: lang_select
      if(preference.lang_select != null){
        this.lang_select = preference.lang_select;
      }
      //// tab[1]: notification
      if(preference.notify_success != null){
        this.notify_success = preference.notify_success;
      }
      if(preference.notify_limit != null){
        this.notify_limit = preference.notify_limit;
      }
      if(preference.web_socket != null
        && this.notify_success){
        this.web_socket = preference.web_socket;
      }
      if(preference.web_socket_job_type != null){
        this.job_type = preference.web_socket_job_type;
      }else{
        this.job_type = this.job_types.map(x => x.value);
      }
      //// tab[2]: http_log
      if(preference.http_log_limit != null){
        this.http_log_limit = preference.http_log_limit;
      }
      if(preference.web_socket_log_limit != null){
        this.web_socket_log_limit = preference.web_socket_log_limit;
      }
    }else{
      this.job_type = this.job_types.map(x => x.value);
    }
  },
  methods: {
    save: function(){
      var preference = {};
      if(this.$store.getters.preference != null){
        preference = this.$store.getters.preference;
      }
      // preference_panel[0]: translate_train
      //// tab[0]: translate
      /*
      if(this.$refs.translate_parameter != null){
        var translate_parameter = this.$refs.translate_parameter;
        preference.translate = {
          command_type: translate_parameter.command_type,
          purpose: translate_parameter.parameters.purpose,
          source_lang: translate_parameter.parameters.source_lang,
          target_lang: translate_parameter.parameters.target_lang,
        };
      }
      */
      //// tab[1]: train
      if(this.$refs.train_parameter != null){
        var train_parameter = this.$refs.train_parameter;
        preference.train = {
          purpose: train_parameter.parameters.purpose,
          source_lang: train_parameter.parameters.source_lang,
          target_lang: train_parameter.parameters.target_lang
        }
        if(train_parameter.selected_field.length > 0){
          preference.train.field = train_parameter.selected_field[0]
        }
        preference.train.detail = train_parameter.parameters.detail;
      }
      // preference_panel[1]: editor
      //// tab[0]: editor
      preference.editor = {};
      preference.editor.content_mode = this.content_mode;
      preference.editor.enable_backup = this.enable_backup;
      preference.editor.history_limit = this.history_limit;
      preference.editor.case_sensitive = this.case_sensitive;
      preference.editor.font_size = this.font_size;
      preference.editor.layout_mode = this.layout_mode;
      preference.editor.menu_mode = this.menu_mode;
      preference.editor.sentence_mode = this.sentence_mode;
      preference.editor.memo_mode = this.memo_mode;
      //this.$store.commit("editor/setContentMode", preference.editor.content_mode);
      this.$store.commit("editor/setEnableBackup", preference.editor.enable_backup);
      this.$store.commit("editor/setHistoryLimit", preference.editor.history_limit);
      this.$store.commit("editor/setSearchCaseSensitive", preference.editor.case_sensitive);
      this.$store.commit("editor/setFontSize", preference.editor.font_size);
      this.$store.commit("editor/setLayoutMode", preference.editor.layout_mode);
      this.$store.commit("editor/setMenuMode", preference.editor.menu_mode);
      this.$store.commit("editor/setSentenceMode", preference.editor.sentence_mode);
      this.$store.commit("editor/setMemoMode", preference.editor.memo_mode);
      //// tab[1]: shortcut
      preference.editor.shortcut = this.shortcut;
      this.$store.commit("editor/setShortcut", preference.editor.shortcut);
      //// tab[2]: colors
      preference.editor.colors = this.colors;
      // preference_panel[2]: system
      //// tab[0]: lang_select
      preference.lang_select = this.lang_select;
      if(this.$i18n.locale != this.lang_select){
        var lang = this.lang_select;
        if(this.lang_select === "auto"){
          lang = (window.navigator.languages && window.navigator.languages[0]) ||
                  window.navigator.language ||
                  window.navigator.userLanguage ||
                  window.navigator.browserLanguage;
          if(Object.keys(this.$store.getters.langs).indexOf(lang) === -1){
            lang = "en";
          }
        }
        this.$i18n.locale = lang;
        this.$vuetify.lang.current = lang;
      }
      //// tab[1]: notification
      preference.notify_success = this.notify_success;
      preference.notify_limit = this.notify_limit;
      if(preference.notify_limit !== -1
        && this.notifications.length > preference.notify_limit){
        while(this.notifications.length > preference.notify_limit){
          this.notifications.pop();
        }
      }
      if(this.notify_success){
        preference.web_socket = this.web_socket;
      }else{
        preference.web_socket = false;
      }
      preference.web_socket_job_type = this.job_type;
      //// tab[2]: http_log
      preference.http_log_limit = this.http_log_limit;
      while(this.http_log.length > preference.http_log_limit){
        this.http_log.pop();
      }
      preference.web_socket_log_limit = this.web_socket_log_limit;
      while(this.web_socket_log_limit.length > preference.web_socket_log_limit){
        this.web_socket_log.pop();
      }

      if(this.$store.getters.debug){
        console.log(preference);
      }
      try{
        localStorage.setItem(this.$store.getters.domain + '_preference', JSON.stringify({
          utime: Math.floor(new Date() / 1000),
          format: {
            type: "preference",
            ver: 2
          },
          preference: preference
        }));
      }catch(e){
        // エラールート
        if(this.$store.getters.debug){
          console.error("setItem preference:" + e);
        }
        this.$store.commit("setNotification", {
          type: "warning",
          message: {
            eid: "E1" + this.module_id + "106" + ":00000002",
            param: {}
          }
        });
        return;
      }
      this.$store.commit("setPreference", preference);
      this.$store.commit("setNotification", {
        type: "success",
        message: {
          eid: "E1" + this.module_id + "004" + ":00000000",
          param: {}
        }
      });
    },
    reset: function(){
      try{
        localStorage.removeItem(this.$store.getters.domain + '_preference');
      }catch(e){
        // エラールート
        if(this.$store.getters.debug){
          console.error("removeItem preference:" + e);
        }
        this.$store.commit("setNotification", {
          type: "warning",
          message: {
            eid: "E1" + this.module_id + "106" + ":00000003",
            param: {}
          }
        });
      }
      this.$store.commit("setPreference", null);
      // 初期値を設定
      // preference_panel[0]: translate_train
      this.reset_translate_train();
      // preference_panel[1]: editor
      this.reset_editor();
      this.$store.commit("editor/setEnableBackup", this.enable_backup);
      this.$store.commit("editor/setHistoryLimit", this.history_limit);
      this.$store.commit("editor/setSearchCaseSensitive", this.case_sensitive);
      this.$store.commit("editor/setFontSize", this.font_size);
      this.$store.commit("editor/setLayoutMode", this.layout_mode);
      this.$store.commit("editor/setMenuMode", this.menu_mode);
      this.$store.commit("editor/setSentenceMode", this.sentence_mode);
      this.$store.commit("editor/setMemoMode", this.memo_mode);
      this.$store.commit("editor/setShortcut", this.shortcut);
      // preference_panel[2]: system
      this.reset_system();
      var lang = (window.navigator.languages && window.navigator.languages[0]) ||
                  window.navigator.language ||
                  window.navigator.userLanguage ||
                  window.navigator.browserLanguage;
      if(Object.keys(this.$store.getters.langs).indexOf(lang) === -1){
        lang = "en";
      }
      this.$i18n.locale = lang;
      this.$vuetify.lang.current = lang;

      this.$store.commit("setNotification", {
        type: "success",
        message: {
          eid: "E1" + this.module_id + "004" + ":00000000",
          param: {}
        }
      });
    },
    reset_translate_train: function(){
      // 初期値を設定
      // preference_panel[0]: translate_train
      //// tab[0]: translate
      /*
      if(this.$refs.translate_parameter != null){
        var translate_parameter = this.$refs.translate_parameter;
        translate_parameter.command_type = "translate";
        translate_parameter.parameters.purpose = "standard";
        if(this.$store.getters.user
          && this.$store.getters.user.allowed_purposes
          && this.$store.getters.user.allowed_purposes.indexOf("standard") < 0
          && this.$store.getters.user.allowed_purposes.length > 0){
          translate_parameter.parameters.purpose
            = this.$store.getters.user.allowed_purposes[0];
        }
        translate_parameter.parameters.source_lang = "en";
        translate_parameter.parameters.target_lang = "ja";
      }
      */
      //// tab[1]: train
      if(this.$refs.train_parameter != null){
        var train_parameter = this.$refs.train_parameter;
        train_parameter.parameters.purpose = "standard";
        if(this.$store.getters.user
          && this.$store.getters.user.allowed_purposes
          && this.$store.getters.user.allowed_purposes.indexOf("standard") < 0
          && this.$store.getters.user.allowed_purposes.length > 0){
          train_parameter.parameters.purpose
            = this.$store.getters.user.allowed_purposes[0];
        }
        train_parameter.parameters.source_lang = "en";
        train_parameter.parameters.target_lang = "ja";
        train_parameter.selected_field = [];
        train_parameter.parameters.detail = {
          fisher_multiplier: 1000000
        };
        train_parameter.lambda = 6.0
      }
    },
    reset_editor: function(){
      // 初期値を設定
      // preference_panel[1]: editor
      // tab[0]: editor
      this.content_mode = "translated";
      this.enable_backup = true;
      this.history_limit = 20;
      this.case_sensitive = false;
      this.font_size = 0.875;
      this.layout_mode = "vertical";
      this.menu_mode = "icon";
      this.sentence_mode = "horizontal";
      this.memo_mode = false;
      // tab[1]: shortcut
      this.shortcut = this.default_shortcut();
      // tab[2]: colors
      this.colors = this.default_colors();
    },
    reset_system: function(){
      // 初期値を設定
      // preference_panel[2]: system
      // tab[0]: lang_select
      this.lang_select = "auto";
      // tab[1]: notification
      this.notify_success = true;
      this.notify_limit = -1;
      this.web_socket = false;
      this.job_type = this.job_types.map(x => x.value)
      // tab[2]: http_log
      this.http_log_limit = 10;
      this.web_socket_log_limit = 30;
    },
    get_color: function(type, name){
      var colors = this.colors;
      var color = _cloneDeep(colors[name]);
      return color;
    },
    get_border_style: function(type, name){
      var color = this.get_color(type, name);
      var border_style = "1px " + color.border_style + " " + color.border_color;
      if(color.border_style.startsWith("bold_")){
        border_style = "2px " + color.border_style.split("_")[1] + color.border_color;
      }
      return {
        border: border_style,
        backgroundColor: color.background_color
      };
    },
    get_text_style: function(name){
      var color = this.get_color("text", name);
      return {
        "color": color.color,
        "fontWeight": color.bold ? "bold" : "normal"
      };
    },
    select_all_toggle: function(){
      this.$nextTick(() => {
        if(this.job_types.length === this.job_type.length){
          this.job_type = []
        }else{
          this.job_type = this.job_types.map(x => x.value);
        }
      })
    },
  },
  computed: {
    ...mapGetters([
      'notifications',
      'http_log',
      'web_socket_log'
    ]),
    keys: function(){
      return function(current){
        var key_set = new Set();
        for(var c of "ABCDEFGHIJKLMOPRSUVXYZ12789"){
          // 以下の文字は乗っ取れないので除外
          // - N: ctrl/cmd + Nで「新しいウィンドウを開く」
          // - T: ctrl/cmd + Tで「新しいタブを開く」
          // - W: ctrl/cmd + Wで「タブを閉じる」
          // - Q: ctrl/cmd + Qで「ブラウザを閉じる」他
          // - 0: Windowsで動作しない
          // - 3〜6: Macでshift + cmd + 3〜6で「スクリーンショットを撮る」等
          key_set.add(c);
        }
        for(var key in this.shortcut){
          if(this.shortcut[key].shift !== current.shift){
            continue;
          }
          if(this.shortcut[key].key === current.key){
            continue;
          }
          key_set.delete(this.shortcut[key].key);
        }
        if(!(current.shift)
          && navigator.userAgent.toLowerCase().indexOf("firefox") >= 0){
          key_set.delete("V");
        }
        var keys = [
          {
            label: "-",
            value: ""
          }
        ];
        for(var c of key_set){
          keys.push({
            label: c,
            value: c
          });
        }
        return keys;
      }
    },
    border_style: function(){
      return function(style){
        var border_style = "1px " + style;
        if(style.startsWith("bold_")){
          border_style = "2px " + style.split("_")[1];
        }
        return {
          "--border_style": border_style
        };
      }
    },
    job_types: function(){
      var domain = "";
      var role = "";
      if(this.$store.getters.user){
        domain = this.$store.getters.user.domain;
        role = this.$store.getters.user.role;
      }
      var job_types = [];
      for(var job_type of this.job_types_all){
        if(job_type.invalid_domains.indexOf(domain) >= 0
          || (job_type.invalid_roles.indexOf(role) >= 0 && this.mode === "user")){
          continue;
        }
        job_types.push({
          label: this.$i18n.t('message.job.job_type_' + job_type.label),
          value: job_type.value
        });
      }
      return job_types;
    },
    select_all_icon: function() {
      if(this.job_types.length === this.job_type.length){
        return 'mdi-close-box';
      }else if(this.job_type.length === 0){
        return 'mdi-checkbox-blank-outline';
      }else{
        return 'mdi-minus-box';
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.v-tooltip__content {
  background: gray;
  opacity: 1 !important;
  white-space: pre-wrap;
}
.accordion{
  border-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.v-expansion-panel::before{
  box-shadow: none;
}
.border_style {
  position: relative;
}
.border_style::before {
  content: "";
  position: absolute;
  border-top: var(--border_style);
  top: 50%;
  width: 60px;
}
</style>
